<template>
	<v-autocomplete
		v-model="currentValue"
		:items="currentOptions"
		item-text="optionName"
		item-value="value"
		:value-comparator="sameVariant"
		outlined
		:label="label || $t('variant')"
		:disabled="!ready || disabled"
		:loading="!ready && !disabled"
		:clearable="clearable"
		clear-icon="icon-cross"
		append-icon="icon-angle-down"
		:rules="rules"
		@change="changeAction"
		@update:search-input="onSearch"
	/>
</template>

<script>
import remote from "../../data/remote";

export default {
	name: "ProductSelect",
	props: {
		value: Object,
		eager: Boolean,
		label: String,
		clearable: Boolean,
		disabled: Boolean,
		rules: Array,
	},
	data() {
		return {
			currentValue: null,
			currentOptions: [],
			ready: false,
			searchTerm: "",
		};
	},
	computed: {
		$lang() {
			return this.$i18n.locale;
		},
	},
	watch: {
		value(v) {
			this.currentValue = v;
			this.ensureCurrentOption();
		},
	},
	methods: {
		sameVariant(a, b) {
			return a && b && a.variantId === b.variantId;
		},
		ensureCurrentOption() {
			if (!this.currentValue) return;
			const exists = this.currentOptions.find((o) => this.sameVariant(o.value, this.currentValue));
			if (!exists) {
				const labelText =
					this.currentValue.label ||
					(this.currentValue.code && this.currentValue.name
						? `${this.currentValue.code} – ${this.currentValue.name}`
						: "");
				this.currentOptions.push({
					value: this.currentValue,
					optionName: labelText,
				});
			}
			this.ready = true;
		},
		handleOptions(variants) {
			this.currentOptions = variants.map((v) => ({
				value: {
					productId: v.productId,
					variantId: v.id,
					code: v.code,
					name: v.name,
				},
				optionName: `${v.code} – ${v.name}`,
			}));
			this.ensureCurrentOption();
			this.ready = true;
		},
		loadOptions() {
			remote.products.select({
				text: this.searchTerm || undefined,
				lang: this.$lang,
				onSuccess: (data) => this.handleOptions(data.items),
				onFail: () => {
					this.ready = true;
				},
			});
		},
		onSearch(val) {
			this.searchTerm = val;
			if (this.currentOptions.some((o) => o.optionName === val)) {
				this.ready = true;
				return;
			}
			this.ready = false;
			this.loadOptions();
		},
		changeAction(val) {
			this.$emit("input", val);
			this.$emit("change", val);
		},
	},
	created() {
		this.currentValue = this.value || null;
		this.ensureCurrentOption();
		if (this.eager && !this.disabled) this.loadOptions();
	},
};
</script>
